module.exports = __webpack_public_path__ + "static/img/gzhcode.89694a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/home/gzhcode.jpg
// module id = DoLj
// module chunks = 27